export enum WorkActionOption {
  PERFORM = "perform",
  OPEN = "open",
  CHOOSE = "choose",
}

export enum DarkModeOption {
  OFF = "off",
  ON = "on",
  SYSTEM = "system",
}
